import React, { VFC } from 'react';
import styled from 'styled-components';
import { IIconProps } from './types';

const Wrapper = styled.div`
  display: block;
  margin: auto auto;
`;

const ArrowRightIcon: VFC<IIconProps> = ({ color, size }) => (
  <Wrapper>
    <svg
      width={size}
      height={size}
      viewBox="-1 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6L21 12L15 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12L21 12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Wrapper>
);
export default ArrowRightIcon;
